<template>
  <v-container class="pa-0 mt-md-2">
    <v-row no-gutters>
      <v-col
        cols="12"
        md="10"
        lg="8"
        offset-md="1"
        offset-lg="2"
      >
        <v-card
          flat
          tile
          class="pa-3"
        >
          <v-toolbar flat>
            <v-btn
              icon
              to="/eleave/list"
            >
              <v-icon>{{ mdiArrowLeft }}</v-icon>
            </v-btn>
            <v-toolbar-title>
              {{ $t('eLeave.TransferAL') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-form ref="transferForm">
            <v-row dense>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.approver"
                  :rules="rules.requiredField"
                  :label="$t('eLeave.Sender')"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.name"
                  :rules="rules.requiredField"
                  :label="$t('TrainingClient.Identity.name')"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.position"
                  :rules="rules.requiredField"
                  :label="$t('Subsidy.CategoryOrCareer')"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.department"
                  :rules="rules.requiredField"
                  :label="$t('Subsidy.Subunit')"
                />
              </v-col>
            </v-row>

            <br>

            <div class="text-subtitle-2 my-n2">
              {{ $t('msg_ferias_transfer_days') }}
            </div>

            <v-row dense>
              <v-col
                cols="6"
                md="4"
              >
                <v-text-field
                  v-model="form.transferDayPersonal"
                  :rules="rules.mustBeNumber"
                  :label="$t('msg_personal_reason')"
                />
              </v-col>

              <v-col
                cols="6"
                md="4"
              >
                <v-text-field
                  v-model="form.transferDayWorking"
                  :rules="rules.mustBeNumber"
                  :label="$t('msg_working_reason')"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col
                cols="12"
                md="8"
              >
                <v-text-field
                  v-if="form.transferDayWorking && ~~form.transferDayWorking > 0"
                  v-model="form.transferDayWorkingDesc"
                  :label="$t('eLeave.TransferLeave.WorkingDesc')"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col
                cols="12"
                md="8"
              >
                <s-search-staff
                  :select.sync="form.assignedToEuid"
                  :staff.sync="toStaffObj"
                  :label="$t('Training.SubmitTarget')"
                  show-group
                />
              </v-col>
            </v-row>

            <br>

            <v-btn
              :loading="loading"
              color="primary"
              class="mr-2"
              @click="showingConfirmDialog = true"
            >
              {{ $t('Text.Submit') }}
            </v-btn>

            <s-confirm-dialog
              v-model="showingConfirmDialog"
              :message="$t('eLeave.SubmitConfirmation')"
              :true-label="$t('ConfirmModal.OK')"
              :false-label="$t('Text.Cancel')"
              @confirm="submit"
            />

            <br><br>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import SSearchStaff from '../../components/SSearchStaff'
import SConfirmDialog from '@/components/SConfirmDialog'
import { staffModule, eLeaveModule, globalModule } from '../../store/moduleName'
import { mapState } from 'vuex'
import store from '../../store'
import eLeave from '../../store/modules/leave/eLeave'
import eLeaveApi from '../../api/leave/eLeave'
import { ID_SIGN_COMPLETE_CB_URL, LOADING_TIMEOUT, BUSINESS_CODE } from '../../constant/constant'
import signHelper from '../../helper/signHelper'
// import VuetifyJetValidator from 'vuetify-jet-validator'
import VuetifyJetValidatorPlus from '@/plugins/vuetifyJetValidatorPlus'
import { mdiArrowLeft } from '@mdi/js'
import { eLeaveMethod } from '@/views/Eleave/mixins/eLeaveMethod'

if (!store.state[eLeaveModule]) store.registerModule(eLeaveModule, eLeave)

const validator = new VuetifyJetValidatorPlus()

export default {
  components: {
    SSearchStaff,
    SConfirmDialog
  },
  mixins: [eLeaveMethod],
  data: function () {
    return {
      mdiArrowLeft: mdiArrowLeft,
      form: {
        approver: this.$t('Subsidy.DirectorOrSubdirector'),
        name: null,
        position: null,
        department: null,
        assignedToEuid: null,
        assignedToGroupId: null,
        transferDayPersonal: null,
        transferDayWorking: null,
        transferDayWorkingDesc: null
      },
      loading: false,
      showingConfirmDialog: false,
      toStaffObj: null,
      rules: {
        requiredField: [
          validator.rules.required(this.$t('TrainingClient.RequiredField'))
        ],
        mustBeNumber: [
          validator.rules.isNumber(this.$t('PublicServant.Error.General.NumericOnly'))
        ]
      }
    }
  },
  computed: {
    ...mapState({
      staff: state => state[staffModule].info,
      appraiser: state => state[staffModule].appraiser
      // transferForm: state => state[eLeaveModule].transferForm
    })
  },
  async created () {
    if (!this.staff) {
      await this.$store.dispatch(staffModule + '/getStaff')
    }
    this.form.name = this.$chPtObjData('chinName', this.staff)
    this.form.position = this.$chPtObjData('careerChinDesc', this.staff)
    this.form.department = this.$chPtObjData('subunitChinName', this.staff)
    // this.form.assignedToEuid = this.staff.defaultNextEuid
    this.form.assignedToEuid = this.appraiser.euid
    this.setApproverByLastFormMetas(this.form, BUSINESS_CODE.ELEAVE_TRANSFER)
  },
  methods: {
    submit: function () {
      this.loading = true
      if (!this.$refs.transferForm.validate()) {
        this.loading = false
        return false
      }

      if (this.toStaffObj && this.toStaffObj.definedGroupId) {
        this.form.assignedToEuid = null
        this.form.assignedToGroupId = this.toStaffObj.definedGroupId
      }
      if ((!this.form.transferDayWorking && !this.form.transferDayPersonal) ||
      (this.form.transferDayWorking === '0' && this.form.transferDayPersonal === '0') ||
      (this.form.transferDayWorking === '0' && !this.form.transferDayPersonal) ||
      (!this.form.transferDayWorking && this.form.transferDayPersonal === '0')) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('msg_ferias_transfer_days')]))
        this.loading = false
        return false
      }
      if (this.form.transferDayWorking && ~~this.form.transferDayWorking > 0 && (!this.form.transferDayWorkingDesc || this.form.transferDayWorkingDesc.length < 3)) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsFillIn', [this.$t('eLeave.TransferLeave.WorkingDesc')]))
        this.loading = false
        return false
      }
      if (!this.form.assignedToEuid && !this.form.assignedToGroupId) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('TrainingClient.ChooseSubmitTarget'))
        this.loading = false
        return false
      }

      this.form.callbackUrl = ID_SIGN_COMPLETE_CB_URL
      // this.$store.dispatch(eLeaveModule + '/assignTransferForm', this.form)
      let finalForm = JSON.stringify(this.form)
      let signObj = {}
      signObj[signHelper.GET_SIGN_LINK_URL] = eLeaveApi.transferGetSignLinkUrl
      signObj[signHelper.SIGN_AND_START_WORKFLOW_URL] = eLeaveApi.transferSignAndStartWorkflowUrl
      signObj[signHelper.REDIRECT_PATH] = '/eleave/list'
      signObj[signHelper.POST_FORM] = finalForm
      signObj[signHelper.SUCCESS_MSG_KEY] = 'TrainingClient.SaveSuccess'
      signObj[signHelper.FAIL_MSG_KEY] = 'Subsidy.AppForm.FailMessage'

      // console.log('form: ' + finalForm)
      signHelper.signAndStartWorkflow(signObj)
      setTimeout(() => {
        this.loading = false
      }, LOADING_TIMEOUT)
    }
  }
}
</script>
